import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Role } from './dtos/role';
import { ValidateRoleResponse } from './dtos/validateRoleResponse';

@Injectable({ providedIn: 'root' })
export class RolesService {
    private rolesUrl = this.baseUrl + '/api/roles';

    public constructor(
        private http: HttpClient,
        private toastr: ToastrService,
        @Inject('API_BASE_URL') private baseUrl: string) { }

    public getAll(): Observable<Role[]> {
        return this.http.get<Role[]>(this.rolesUrl + '/GetAll')
            .pipe(
                catchError(this.handleError<Role[]>('getAll'))
            );
    }

    public addRole(roleToAdd: Role): Observable<string> {
        return this.http.post<string>(this.rolesUrl + '/Add', roleToAdd)
            .pipe(
                tap(() => this.toastr.success('Saved Sucessfully')),
                catchError(this.handleError<string>('addRole'))
            );
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public updateRole(roleToUpdate: Role): Observable<any> {
        return this.http.put(this.rolesUrl + '/Update/' + roleToUpdate.id, roleToUpdate)
            .pipe(
                tap(() => this.toastr.success('Saved Sucessfully')),
                catchError(this.handleError<Role>('updateRole'))
            );
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public deleteRole(roleId: string): Observable<any> {
        return this.http.delete(this.rolesUrl + '/Delete/' + roleId)
            .pipe(
                tap((deleted) => {
                    if (deleted) {
                        this.toastr.success('Deleted Sucessfully');
                    }
                }),
                catchError(this.handleError<Role>('deleteRole'))
            );
    }

    public validateRole(roleToValidate: Role): Observable<ValidateRoleResponse> {
        return this.http.post<ValidateRoleResponse>(this.rolesUrl + '/Validate', roleToValidate)
            .pipe(
                catchError(this.handleError<ValidateRoleResponse>('validateRole'))
            );
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    private handleError<T>(operation = 'operation', result?: T | undefined): (err: any) => Observable<T> {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (error: any): Observable<T> => {

            console.error('An error occurred', error);
            this.toastr.error(`${operation} failed: ${error.message}`);

            throw error;
        };
    }
}
